export const DECLARATION_DATA_FETCH_INIT = 'DECLARATION_DATA_FETCH_INIT';
export const DECLARATION_DATA_FETCH_SUCCESS = 'DECLARATION_DATA_FETCH_SUCCESS';
export const DECLARATION_DATA_FETCH_ERROR = 'DECLARATION_DATA_FETCH_ERROR';

export const DECLARATION_DATA_POST_INIT = 'DECLARATION_DATA_POST_INIT';
export const DECLARATION_DATA_POST_SUCCESS = 'DECLARATION_DATA_POST_SUCCESS';
export const DECLARATION_DATA_POST_ERROR = 'DECLARATION_DATA_POST_ERROR';

export const DECLARATION_DATA_RESET = 'DECLARATION_DATA_RESET';
